import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { View } from './pages/View';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <View />
  </React.StrictMode>
);
